<template>
  <v-master
    :background="background"
  >
    <div class="md:pt-navbar-desktop md:pb-0 pb-navbar-mobile relative w-full overflow-x-hidden">
      <div class="md:hidden border-primary-500 flex items-center justify-center w-full py-3 mb-0 bg-white border-t-4">
        <img
          src="/img/icons/svg/logo-navbar-tagline.svg"
          alt="Carbonii"
          class="w-40"
        >
      </div>

      <slot />
    </div>
    <transition
      enter-active-class="duration-800 transition ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-800 transition ease-in delay-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <v-loading v-if="loading" />
    </transition>
    <v-navbar-mobile class="md:hidden" />
    <v-navbar-desktop class="md:flex hidden" />

    <v-confirmation
      :show="showWelcomeModal"
      @close="showWelcomeModal = false"
    >
      <template #action>
        <router-link
          :to="'/subscription'"
          class="btn btn-primary w-full mt-6 no-underline"
        >
          Offset my carbon footprint
        </router-link>
      </template>
    </v-confirmation>
  </v-master>
</template>

<script>
import confirmation from "./views/includes/confirmation-modal.vue";
export default {
  name: "v-layout",
  components: {
    "v-confirmation": confirmation
  },
  props: {
    background: {
      default: true,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      showWelcomeModal: false
    };
  },
  created() {
    if (this.$route.query.welcome && this.$route.query.welcome == 1) {
      this.showWelcomeModal = true;
    }
  }
};
</script>
